import { suitableForGroups, siteConfig } from '@/mocks/data';

export default function SuitableForSection() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, evim için Fineco Isı Pompası uygun mu öğrenmek istiyorum. Bilgi alabilir miyim?')}`;

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Fineco Isı Pompası Kimler İçin Uygun?
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {suitableForGroups.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70 flex flex-col items-center text-center gap-3 hover:border-primary-200/50 transition-colors group"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm text-foreground-700 font-medium leading-snug">{item.text}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#1faa51] transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
            Eviniz İçin Uygun Mu? WhatsApp'tan Sorun
          </a>
        </div>
      </div>
    </section>
  );
}